import { IconButton, makeStyles } from '@material-ui/core'
import React, { useContext } from 'react'
// eslint-disable-next-line no-unused-vars
import DeleteIcon from '@material-ui/icons/DeleteOutline'
import EditIcon from '@material-ui/icons/EditOutlined'
import { TableContext } from './TableProvider'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  icon: {
    color: theme.palette.primary.main,
  },
}))

const TableAction = ({ rowData }) => {
  const classes = useStyles()
  const {
    getShow, setOpenDialog, setAlertDialog, setDeleteId,
  } = useContext(TableContext)

  const onClickEdit = () => {
    setOpenDialog(true)
    getShow(rowData.id)
  }

  const onClickDelete = () => {
    setDeleteId(rowData.id)
    setAlertDialog(true)
  }

  return (
    <div className={classes.root}>
      <IconButton onClick={onClickEdit}>
        <EditIcon className={classes.icon} />
      </IconButton>
      <IconButton onClick={onClickDelete}>
        <DeleteIcon className={classes.icon} />
      </IconButton>
    </div>
  )
}

export default TableAction
